<template>
  <a-drawer
    :visible="visible"
    :title="`Disbursement #${disbursementData && disbursementData.disbursementId ? disbursementData.disbursementId : ''} Details`"
    placement="right"
    width="600px"
    @close="handleClose"
    :closable="true"
  >
    <div v-if="disbursementData" style="padding: 0 16px">
      <!-- Disbursement Information Section -->
      <div style="margin-bottom: 32px">
        <h3 style="margin-bottom: 16px; font-size: 16px; font-weight: 600;">
          Disbursement Information
        </h3>
        <div style="background: #f9fafb; padding: 20px; border-radius: 8px">
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px">
            <div>
              <p style="margin: 0 0 4px 0; font-size: 12px; color: #6b7280; font-weight: 500">
                Disbursement ID
              </p>
              <p style="margin: 0; font-size: 14px; font-weight: 600;">
                {{ disbursementData.disbursementId }}
              </p>
            </div>
            <div>
              <p style="margin: 0 0 4px 0; font-size: 12px; color: #6b7280; font-weight: 500">
                Status
              </p>
              <StatusTag :status="disbursementData.status" />
            </div>
            
            <div>
              <p style="margin: 0 0 4px 0; font-size: 12px; color: #6b7280; font-weight: 500">
                Seller
              </p>
              <p style="margin: 0; font-size: 14px; font-weight: 600;">
                {{ disbursementData.sellerName }}
              </p>
            </div>
            <div>
              <p style="margin: 0 0 4px 0; font-size: 12px; color: #6b7280; font-weight: 500">
                Amount
              </p>
              <p style="margin: 0; font-size: 14px; font-weight: 600;">
                {{ formatAmount(disbursementData.amount) }}
              </p>
            </div>
            <div>
              <p style="margin: 0 0 4px 0; font-size: 12px; color: #6b7280; font-weight: 500">
                Factoring Request ID
              </p>
              <p style="margin: 0; font-size: 14px; font-weight: 600; cursor: pointer">
                {{ disbursementData.factoringRequestId }}
              </p>
            </div>
            <div v-if="disbursementData.status && disbursementData.status.toLowerCase() !== 'success'">
              <p style="margin: 0 0 4px 0; font-size: 12px; color: #6b7280; font-weight: 500">
                Reason
              </p>
              <p style="margin: 0; font-size: 14px; font-weight: 500; color: #6b7280; background: #f9fafb;">
                {{ disbursementData.terraResponseMessage ? disbursementData.terraResponseMessage : "N/A" }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Key Dates Section -->
      <div style="margin-bottom: 32px">
        <h3 style="margin-bottom: 16px; font-size: 16px; font-weight: 600;">
          Key Dates
        </h3>
        <div style="background: #f9fafb; padding: 20px; border-radius: 8px">
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px">
            <div>
              <p style="margin: 0 0 4px 0; font-size: 12px; color: #6b7280; font-weight: 500">
                Created at
              </p>
              <p style="margin: 0; font-size: 14px; font-weight: 600;">
                {{ disbursementData.createdOn }}
              </p>
            </div>
            <div>
              <p style="margin: 0 0 4px 0; font-size: 12px; color: #6b7280; font-weight: 500">
                Completed at
              </p>
              <p style="margin: 0; font-size: 14px; font-weight: 600;">
                {{ disbursementData.sentOn }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div v-else-if="loading" style="display: flex; justify-content: center; align-items: center; height: 200px">
      <a-spin size="large" />
    </div>

    <!-- Error State -->
    <div v-else style="display: flex; justify-content: center; align-items: center; height: 200px; color: #6b7280">
      <div style="text-align: center">
        <a-icon type="exclamation-circle" style="font-size: 48px; margin-bottom: 16px; color: #d1d5db" />
        <p>No disbursement data available</p>
      </div>
    </div>

    <!-- Footer -->
    <div style="position: absolute; bottom: 0; left: 0; right: 0; padding: 16px; background: #fff; border-top: 1px solid #e6e6e6">
      <div style="display: flex; justify-content: flex-end; gap: 12px">
        <a-button @click="handleClose" style="border-radius: 6px; background: #26a246; border-color: #26a246; color: #fff">
          Close
        </a-button>
      </div>
    </div>
  </a-drawer>
</template>

<script>
import StatusTag from "../shared-components/StatusTag.vue";
import { formatAmount } from "@/utils";

export default {
  name: "DisbursementDetailsDrawer",
  components: {
    StatusTag,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    disbursementData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    formatAmount,
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.ant-drawer-body {
  padding: 0;
  position: relative;
  padding-bottom: 80px;
}
</style>
